export const archivedProjectTooltip =
  'This option is not available because this project is archived';

export const readOnlyProjectTooltip =
  'This option is not available because you are not a member of this project';
